<template>
  <main class="main" role="main">
    <div class="main__inner"><!-- 배경: bg-->
      <div class="main__con">
        <div class="main__page">
          <div class="p16">
            <form class="search">
              <input type="search" placeholder="검색어를 입력하세요." title="" v-model="searchText" v-on:keydown.enter="$event.preventDefault()">
              <button type="reset" v-show="searchText.length > 0" @click="fnDeleteSearchText"></button><!--★ 텍스트가 입력되면 보여지고, 버튼을 클릭하면 사라지게 작업해주세요 구글 검색창 참고해주세요! ★-->
            </form>
          </div>
          <div class="notice__page">
            <ul class="notice__page__ul">
              <li class="notice__page__li type_02" v-for="(item, index) in tempInquireList" :key="index" @click="fnView(item)">
                <div class="txt_line">
                  <p>{{ item.boardTitle }}</p>
                  <p class="date">{{ $moment(item.regDate).format('YYYY.MM.DD') }}<span class="date ml10"><i class="i_time_gr50"></i>{{ $moment(item.regDate).format('HH:mm') }}</span></p>
                </div>
                <div class="question" :class="{'on':item.isAnswer === 1}">{{ item.isAnswer === 1 ? '답변완료' : '답변대기'}}</div>
              </li>
            </ul>
            <infinite-loading @infinite="getInquireList">
              <div slot="spinner"></div>
              <div slot="no-more"></div>
              <div slot="no-results">
                <div class="complete">
                  <img src="@/assets/static/images/img_notice.svg" alt="" class="complete__img">
                  <span class="complete__txt__type02">내역이 없습니다.</span>
                </div>
              </div>
            </infinite-loading>
          </div>
        </div>
      </div>
      <div class="btn_wrap btn_wrap__fixed">
        <button class="btm on" @click="fnForm">문의 등록</button> <!--활성화: on-->
      </div>
    </div>
  </main>
</template>
<script>
import InfiniteLoading from 'vue-infinite-loading'
export default {
  components: {InfiniteLoading},
  data: function () {
    return {
      params: {
        page: 1,
        limit: 99999,
        boardType: 3,
        userNo: this.$store.getters['account/getUserData'].userNo
      },
      searchText: '',
      pageInfo: {},
      inquireList: []
    }
  },
  computed: {
    tempInquireList: function() {
      const searchList = []
      if (this.searchText.trim().length <= 0) {
        return this.inquireList
      } else {
        this.inquireList.filter(item => {
          if (item.boardTitle.indexOf(this.searchText) >= 0) {
            searchList.push(item)
          }
        })
        return searchList
      }
    }
  },
  methods: {
    getInquireList: async function ($state) {
      const res = await this.$MypageSvc.getBoardList(this.params)
      const code = res.code
      const message = res.message
      const entity = res.entity

      console.log('code: %d\nmessage: %s\nentity: %o\nstringify: \n%s', code, message, entity, JSON.stringify(entity))

      if (code === 1) {
        this.isShow = true
        this.inquireList = this.inquireList.concat(entity.list)
        this.pageInfo = entity.pageInfo
        this.params.page = this.params.page + 1

        if (this.pageInfo.page >= this.pageInfo.endPage) {
          $state.complete()
        }
        if (this.pageInfo.totalRow > 0) {
          $state.loaded()
        }
      } else {
        $state.complete()
        this.$Util.modalAlert({message: message})
      }
    },
    fnView: function (item) {
      this.$router.push({
        path: '/mypage/inquireDetail',
        query: {boardNo: item.boardNo}
      })
    },
    fnForm: function () {
      this.$router.push({
        path: '/mypage/inquireForm',
        query: {boardNo: 0}
      })
    },
    fnDeleteSearchText: function () {
      this.searchText = ''
    }
  }
}
</script>
